<template>
  <Modal
    :show="show.generateFieldContentConfirm"
    action-text="Generate"
    @close="close"
    @action="confirm"
  >
    <template #title>
      Generate {{ params.fieldTitle }}
    </template>

    <template #content>
      This will replace the current <strong>{{ params.fieldTitle }}</strong> content (if any) with AI-generated content.
      Are you sure you want to continue?
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import Modal from '@/components/shared/Modal.vue';

const { show, modalParams } = storeToRefs(useModals());
const { setModal } = useModals();
const { fields } = storeToRefs(useCurrentJobProfile());

const params = computed(() => modalParams.value.generateFieldContentConfirm ?? {});

const close = () => setModal({ field: 'generateFieldContentConfirm', value: false });

const confirm = () => {
  const field = fields.value.find((f) => f.content_generator_type === params.value.generatorType);
  if (field) useCurrentJobProfile().generateFieldContent(field);
  close();
};
</script>
